import ActivityPrayer from './ActivityPrayer';

export default ActivityPrayer;
